import React from 'react'
import type { FC } from 'react'
import { Link as RouterLink } from 'react-router'
import { getPathFromPathOrUrl } from './get-path.js'

export interface LinkProps {
  to: string
  external?: boolean
  children: React.ReactNode
}

export const Link: FC<LinkProps> = ({ to: pathOrUrl, external = false, children }) => {
  const to = external ? pathOrUrl : getPathFromPathOrUrl(pathOrUrl)

  if (external) {
    return (
      <a href={to} style={{ color: 'var(--tuna-palette-primary-main)', textDecoration: 'none' }}>
        {children}
      </a>
    )
  }

  return (
    <RouterLink to={to} style={{ color: 'var(--tuna-palette-primary-main)', textDecoration: 'none' }}>
      {children}
    </RouterLink>
  )
}

export default Link
